<template>
  <div>
    <div class="gdlr-core-pbf-wrapper" style="margin-top: 60px; padding: 15px 0px 0px 0px;"
         id="gdlr-core-wrapper-2">
      <div class="gdlr-core-pbf-background-wrap">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
             style="background-image: url(static/upload/about-2-about-bg.png); background-repeat: no-repeat; background-position: top center;"
             data-parallax-speed="0"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first gdlr-core-hide-in-mobile"
               id="gdlr-core-column-38316">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 50px 40px 0px 0px;">
              <div class="gdlr-core-pbf-background-wrap">
                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                     style="background-size: cover; background-position: center;" data-parallax-speed="0"></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr"
                       style="padding-bottom: 50px;">
                    <div
                      class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle"
                      style="border-width: 0px; margin-right: 10px;">
                      <img src="static/upload/iStock-953426638.jpg" alt="" width="900" height="623" title="img 001">
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-right-align gdlr-core-style-vertical"
                    style="margin-bottom: 0px;">
                    <div class="gdlr-core-divider-line gdlr-core-skin-divider"
                         style="border-color: #d32525; height: 90px;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-30" id="gdlr-core-column-7419">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js"
                 style="margin: 0px 0px 110px; padding: 70px 0px 0px 50px; height: 524.68px;"
                 data-sync-height="height-img">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js gdlr-core-sync-height-content">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                    style="padding-bottom: 40px;">
                        <span
                          class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                          style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525;">
                          <span class="gdlr-core-title-item-left-dot"
                                style="width: 5px; height: 5px; background-color: #d32525; margin-right: 15px;"></span>
                          Our Service
                          </span>
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                          style="font-size: 44px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #353535;">
                        跨境架构搭建服务
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-icon-list-item gdlr-core-item-pdlr gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-style-1"
                    style="padding-bottom: 5px;">
                    <ul>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                          <img src="static/upload/logo01.png" alt="" width="120" height="120" title="logo01">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                            提供BVI、CAYMAN、HK公司设立服务
                          </span>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                          <img src="static/upload/logo02.png" alt=""
                               width="120"
                               height="120" title="logo02">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                              <span class="gdlr-core-icon-list-content"
                                    style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">提供CAY&HK开户服务</span>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                          <img src="static/upload/logo03.png" alt=""
                               width="120"
                               height="120" title="logo03">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                              <span class="gdlr-core-icon-list-content"
                                    style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">提供WOFE设立服务</span>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                          <img src="static/upload/logo01.png" alt=""
                               width="120"
                               height="120" title="logo03">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">提供境内居民的外汇备案(37#文)咨询登记</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gdlr-core-pbf-wrapper" style="padding: 0px 0px 20px 0px;">
      <div class="gdlr-core-pbf-background-wrap">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
             style="background-size: cover; background-position: center;" data-parallax-speed="0"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first" id="gdlr-core-column-41226">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 85px 40px 0px 0px;">
              <div class="gdlr-core-pbf-background-wrap">
                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                     style="background-size: cover; background-position: center;" data-parallax-speed="0"></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">
                    <span
                      class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                      style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525;">
                      <span class="gdlr-core-title-item-left-dot"
                            style="width: 5px; height: 5px; background-color: #d32525; margin-right: 15px;"></span>Our Service
                    </span>
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                          style="font-size: 44px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #353535;">
                        境内企业出境投资(ODI)登记服务<span
                        class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-icon-list-item gdlr-core-item-pdlr gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-style-1"
                    style="padding-bottom: 5px;">
                    <ul>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                          <img src="static/upload/logo01.png" alt="" width="120" height="120" title="logo01">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                            提供一站式的出境方案设计服务
                          </span>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                          <img src="static/upload/logo02.png" alt="" width="120" height="120" title="logo01">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                            提供路径公司银行账户的开设服务
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-30" id="gdlr-core-column-85607">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js gdlr-core-column-extend-right"
                 style="padding: 75px 0px 70px 0px;">
              <div class="gdlr-core-pbf-background-wrap">
                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                     style="background-image: url(static/upload/talk-bg00.jpg); background-size: cover; background-position: center;"
                     data-parallax-speed="0"></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr"
                       style="padding-bottom: 0px;">
                    <div
                      class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle"
                      style="border-width: 0px;">
                      <img src="static/upload/talk-bg.jpg" alt="" width="601" height="398" title="talk bg">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gdlr-core-pbf-wrapper" style="margin-top: 60px; padding: 15px 0px 0px 0px;"
         id="gdlr-core-wrapper-2">
      <div class="gdlr-core-pbf-background-wrap">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
             style="background-image: url(static/upload/about-2-about-bg.png); background-repeat: no-repeat; background-position: top center;"
             data-parallax-speed="0"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first gdlr-core-hide-in-mobile"
               id="gdlr-core-column-38316">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 50px 40px 0px 0px;">
              <div class="gdlr-core-pbf-background-wrap">
                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                     style="background-size: cover; background-position: center;" data-parallax-speed="0"></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr"
                       style="padding-bottom: 50px;">
                    <div
                      class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle"
                      style="border-width: 0px; margin-right: 10px;">
                      <img src="static/upload/shutterstock_1226196742.jpg" alt="" width="900" height="623" title="img 001">
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-right-align gdlr-core-style-vertical"
                    style="margin-bottom: 0px;">
                    <div class="gdlr-core-divider-line gdlr-core-skin-divider"
                         style="border-color: #d32525; height: 90px;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-30" id="gdlr-core-column-7419">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js"
                 style="margin: 0px 0px 110px; padding: 70px 0px 0px 50px; height: 524.68px;"
                 data-sync-height="height-img">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js gdlr-core-sync-height-content">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                    style="padding-bottom: 40px;">
                        <span
                          class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                          style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525;">
                          <span class="gdlr-core-title-item-left-dot"
                                style="width: 5px; height: 5px; background-color: #d32525; margin-right: 15px;"></span>
                          Our Service
                          </span>
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                          style="font-size: 44px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #353535;">
                        员工股权激励计划(ESOP)方案设计服务
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-icon-list-item gdlr-core-item-pdlr gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-style-1"
                    style="padding-bottom: 5px;">
                    <ul>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                          <img src="static/upload/logo01.png" alt="" width="120" height="120" title="logo01">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content"
                                style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">
                            方案设计及协议起草
                          </span>
                        </div>
                      </li>
                      <li class="gdlr-core-skin-divider clearfix" style="margin-bottom: 17px;">
                        <span class="gdlr-core-icon-list-image gdlr-core-left"
                              style="max-width: 35px; margin-top: -2px;">
                          <img src="static/upload/logo02.png" alt=""
                               width="120"
                               height="120" title="logo02">
                        </span>
                        <div class="gdlr-core-icon-list-content-wrap">
                              <span class="gdlr-core-icon-list-content"
                                    style="color: #1b1b1b; font-size: 19px; font-weight: 500; text-transform: none;">境外上市公司股权激励计划(7#文)登记服务&HK开户服务</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'ServiceContent2'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/service/ServiceContent2.vue